// pages/Main/sections/LocationsAndRoutes.js
import React from 'react';
import { Link } from 'react-router-dom';

const LocationsRoutesSection = () => {
  return (
    <section id="locationsAndRoutes" className="flex-column">
      <p id="locationsAndRoutesHeader">ЛОКАЦИИ   И   МАРШРУТЫ</p>

      <div id="locationsAndRoutesWrapper" className="flex-row">
        <Link to="/categories/type/locations" className="card-link">
          <div className="locationsAndRoutesCard flex-column">
            <img 
              className="locationsAndRoutesCardPhoto" 
              src="/elements/locationsPhoto.png" 
              alt="Локации" 
            />
            <p className="locationsAndRoutesCardText">Локации</p>
          </div>
        </Link>

        <img 
          id="locationsAndRoutesDivider" 
          src="/elements/divider.svg" 
          alt="Разделитель" 
        />

        {/* Маршруты - передаем параметр type='routes' */}
        <Link to="/categories/type/routes" className="card-link">
          <div className="locationsAndRoutesCard flex-column">
            <img 
              className="locationsAndRoutesCardPhoto" 
              src="/elements/routePhoto.png" 
              alt="Маршруты" 
            />
            <p className="locationsAndRoutesCardText">Маршруты</p>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default LocationsRoutesSection;